<nav class="main-nav-list" [style.width]="isSideMenuOpen() ? '75px' : '97%'">
  <ul>
    @for (sideMenuItem of sideMenuItems; track $index) {
    <li>
      <a
        [routerLink]="'/' + sideMenuItem.route(selectedProgram?._id ?? '')"
        [ngClass]="{ active: isCurrentRouteActive(sideMenuItem) }"
      >
        <img
          [src]="getSideMenuItemIcon(sideMenuItem)"
          [alt]="sideMenuItem.alt"
        />
        <span [hidden]="isSideMenuOpen()">{{
          sideMenuItem.translationPath | translate
        }}</span>
      </a>
    </li>
    }
  </ul>
</nav>
